import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ScrollIntoViewDirective } from '../../scroll-into-view';
import { AvatarComponent } from './avatar.component';
import { UserAvatarNameComponent } from './user-avatar-name/user-avatar-name.component';
import { UserAvatarComponent } from './user-avatar/user-avatar.component';

@NgModule({
  imports: [CommonModule, ScrollIntoViewDirective, AvatarComponent, UserAvatarComponent, UserAvatarNameComponent],
  exports: [AvatarComponent, UserAvatarComponent, UserAvatarNameComponent],
})
export class AvatarModule {}
